/**
 * Scandex Marquee Animation Controller
 * Handles smooth scrolling text with Swedish branding
 */

class ScandexMarquee {
  constructor(element) {
    this.element = element;
    this.content = element.querySelector('.marquee-content');
    this.speed = parseInt(element.dataset.speed) || 3;
    this.direction = element.dataset.direction || 'left';
    this.isAnimating = true;
    
    this.init();
  }

  init() {
    // Check for reduced motion preference
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    this.setupAnimation();
    this.setupEventListeners();
  }

  setupAnimation() {
    // Calculate animation duration - speed range 1-10, where 10 is fastest
    // Convert speed (1-10) to duration (30s-3s)
    const duration = 33 - (this.speed * 3); // Speed 1 = 30s, Speed 10 = 3s
    
    // Apply animation
    this.content.style.animationDuration = `${duration}s`;
    this.content.style.animationDirection = this.direction === 'right' ? 'reverse' : 'normal';
    
    // Ensure animation starts immediately
    this.content.style.animationPlayState = 'running';
  }

  setupEventListeners() {
    // Pause animation on hover (desktop only)
    if (window.matchMedia('(hover: hover)').matches) {
      this.element.addEventListener('mouseenter', () => {
        this.content.style.animationPlayState = 'paused';
      });

      this.element.addEventListener('mouseleave', () => {
        this.content.style.animationPlayState = 'running';
      });
    }

    // Handle window resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.setupAnimation();
      }, 150);
    });

    // Handle visibility changes (pause when tab is not visible)
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.content.style.animationPlayState = 'paused';
      } else {
        this.content.style.animationPlayState = 'running';
      }
    });
  }

  // Public methods for external control
  play() {
    this.content.style.animationPlayState = 'running';
    this.isAnimating = true;
  }

  pause() {
    this.content.style.animationPlayState = 'paused';
    this.isAnimating = false;
  }

  updateSpeed(newSpeed) {
    this.speed = newSpeed;
    this.setupAnimation();
  }

  updateDirection(newDirection) {
    this.direction = newDirection;
    this.content.style.animationDirection = newDirection === 'right' ? 'reverse' : 'normal';
  }
}

// Initialize all marquee sections when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  const marquees = document.querySelectorAll('.scandex-marquee');
  
  marquees.forEach(marquee => {
    new ScandexMarquee(marquee);
  });
});

// Handle Shopify theme editor
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const marquee = event.target.querySelector('.scandex-marquee');
    if (marquee) {
      new ScandexMarquee(marquee);
    }
  });
}

// Intersection Observer for performance optimization
if ('IntersectionObserver' in window) {
  const observerOptions = {
    root: null,
    rootMargin: '50px',
    threshold: 0.1
  };

  const marqueeObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const marquee = entry.target.querySelector('.marquee-content');
      if (marquee) {
        if (entry.isIntersecting) {
          marquee.style.animationPlayState = 'running';
        } else {
          marquee.style.animationPlayState = 'paused';
        }
      }
    });
  }, observerOptions);

  // Observe all marquee sections
  document.addEventListener('DOMContentLoaded', () => {
    const marqueeWrappers = document.querySelectorAll('.scandex-marquee-wrapper');
    marqueeWrappers.forEach(wrapper => {
      marqueeObserver.observe(wrapper);
    });
  });
}